<template>
  <v-form ref="form" lazy-validation @submit.prevent="onSignin">
    <v-card-text>
      <v-row>
        <v-col v-if="project.form.signInDescription" cols="12" v-html="project.form.signInDescription" />
        <v-col v-else cols="12" class="pt-0 pb-11 headline font-weight-light">
          {{ $t('v.enterEmail') }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pb-11">
          <v-text-field v-model="emailModel" :solo="project.form.solo" :outlined="project.form.outlined" :rules="emailRules" label="Email" name="email" type="email" required autofocus autocapitalize="none" autocomplete="username" :dense="project.form.small" @keydown.native.space.prevent />
        </v-col>
      </v-row>

      <v-row align="center">
        <v-spacer />
        <v-col cols="auto">
          <v-btn large :small="project.form.small" :loading="loading" :disabled="loading" color="accent" class="px-11" type="submit">
            {{ $t('v.send') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import StepMixin from './StepMixin'
import { isEmail } from '@/helpers'

export default {
  mixins: [
    StepMixin
  ],

  data: () => ({
    email: '',
    loading: false
  }),

  computed: {
    emailModel: {
      get () {
        return this.email
      },
      set (value) {
        this.email = value ? value.replace(/\s/g, '') : ''
      }
    },

    emailRules () {
      return [v => !!v || this.$t('v.emailRequired'), v => isEmail(v) || this.$t('v.emailInvalid')]
    },

    ...mapGetters({
      project: 'projects/project'
    })
  },

  async mounted () {
    const prefillEmail = await this.usePrefillEmail()
    if (prefillEmail) {
      this.email = prefillEmail
      setTimeout(() => this.onSignin(), 50)
    }
  },

  methods: {
    async onSignin () {
      if (!this.$refs.form.validate()) {
        return false
      }

      try {
        this.loading = true

        const email = this.email.toLowerCase().trim()
        await this.wdotAdd({ event: 'trySignIn', email })

        await this.signInNative({ email })

        const registrationRequired = await this.userRegistrationRequired(email)

        this.next({ email, registrationRequired })
      } catch (error) {
        this.showError(this.$t(error.message))
        this.$logError(error)
      } finally {
        this.loading = false
      }
    },

    ...mapActions({
      signInNative: 'auth/signInNative',
      userRegistrationRequired: 'auth/userRegistrationRequired',
      usePrefillEmail: 'auth/usePrefillEmail',
      wdotAdd: 'wdots/add',
      showMessage: 'notification/showMessage',
      showError: 'notification/showError'
    })
  }
}
</script>

<style scoped>
</style>
